import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import CampaignAnalysis from "./CampaignAnalysis";
import CampaignList from "./CampaignList";
import CampaignEmailDetail from "./CampaignEmailDetail";
import NewCampaign from "./NewCampaign";
import EditCampaign from "./EditCampaign";
import CopyCampaign from "./CopyCampaign";
import SEO from "../../UI/SEO/SEO";
import CampaignTemplateRoutes from "./Template/CampaignTemplateRoutes";
import ParamsService from "../../../Services/Shared/Params.service";
import { getPreBasePath, getPreBaseRoute } from "../../../../components";
export const getCampaignBaseRoute = () => "/app/campaign";
export const getCampaignBasePath = (params) => {
    return getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getCampaignBaseRoute();
};
// Private
const getCampaignEmailRoute = () => `${getCampaignBaseRoute()}/email`;
const getCampaignEditRoute = () => `${getCampaignBaseRoute()}/edit`;
const getCampaignCopyRoute = () => `${getCampaignBaseRoute()}/copy`;
const getCampaignListRoute = () => `${getCampaignBaseRoute()}/list`;
const getCampaignAnalysisRoute = () => `${getCampaignBaseRoute()}/analysis`;
const getCampaignNewRoute = () => `${getCampaignBaseRoute()}/new`;
const getCampaignTemplateRoute = () => `${getCampaignBaseRoute()}/template`;
export const getCampaignListPath = (params) => `${getCampaignBasePath(params)}/list`;
export const getCampaignAnalysisPath = (params) => `${getCampaignBasePath(params)}/analysis`;
export const getCampaignNewPath = (params, virtualizedAppName) => {
    return ParamsService.getURLWithParams(params, getCampaignBasePath({ virtualizedAppName }) + "/new");
};
export const getCampaignTemplatePath = (params) => `${getCampaignBasePath(params)}/template`;
export const getCampaignDetailPath = (params) => params.id == null
    ? getCampaignListPath(params)
    : `${getCampaignBasePath(params)}/email/${params.id}`;
export const getCampaignEditPath = (params) => params.id == null
    ? `${getCampaignBasePath(params)}/edit`
    : `${getCampaignBasePath(params)}/edit/${params.id}`;
export const getCampaignCopyPath = (params) => params.id == null
    ? `${getCampaignBasePath(params)}/copy`
    : `${getCampaignBasePath(params)}/copy/${params.id}`;
const CampaignRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Campaigns" }), _jsxs(Switch, { children: [_jsx(Route, { component: CampaignAnalysis, path: getPreBaseRoute() + getCampaignAnalysisRoute() }), _jsx(Route, { component: CampaignList, path: getPreBaseRoute() + getCampaignListRoute() }), _jsx(Route, { component: CampaignEmailDetail, path: getPreBaseRoute() + `${getCampaignEmailRoute()}/:id` }), _jsx(Route, { component: NewCampaign, path: getPreBaseRoute() + getCampaignNewRoute() }), _jsx(Route, { component: EditCampaign, path: `${getPreBaseRoute() + getCampaignEditRoute()}/:id` }), _jsx(Route, { component: EditCampaign, path: getPreBaseRoute() + getCampaignEditRoute() }), _jsx(Route, { component: CopyCampaign, path: `${getPreBaseRoute() + getCampaignCopyRoute()}/:id` }), _jsx(Route, { component: CampaignTemplateRoutes, path: getPreBaseRoute() + getCampaignTemplateRoute() })] })] }));
export default CampaignRoutes;
